import cn from 'classnames';
import styles from './Paper.module.css';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Paper = ({ children, className }: Props): JSX.Element => (
  <div className={cn(styles.Paper, className)}>{children}</div>
);

export default Paper;
